import { Component, OnDestroy, Input, OnInit } from '@angular/core';
import { CookieService } from 'angular2-cookie/core';
import { KartinaErrorsService } from '../../../services/kartina-errors-service';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'system-messages',
    template: require('./system-messages.component.html')
})
export class SystemMessagesComponent implements OnDestroy, OnInit {
    public messagesVisible = false;
    public messages: string[] = []; //messages from cookiesService, they will transfer into danger

    @Input('warning') warning: string[];
    @Input('danger') danger: any[];
    @Input('success') success: string[];
    @Input('info') info: string[];
    @Input('useHtml') useHtml = false;

    @Input('ignoreCookies') ignoreCookies = false;

    private errorsSubscription: Subscription;

    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly cookiesService: CookieService,
        private readonly errorsService: KartinaErrorsService) {
    }

    ngOnInit() {
        if (!this.ignoreCookies) {
            const msg = this.cookiesService.get('system-message');
            if (!!msg) {
                this.messagesVisible = true;
                this.danger = [this.sanitizer.bypassSecurityTrustHtml(msg)];
            }

            this.errorsSubscription = this.errorsService.update.subscribe((message) => {
                this.messagesVisible = true;
                if (message !== '') {
                    this.danger = [message];
                }
            });
        }
    }

    ngOnDestroy(): void {
        if (this.errorsSubscription) {
            this.errorsSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/system-message/system-messages.component.ts